export default "__VITE_ASSET__r7Wo405b__"